import { MenuFreshnessBadge } from "./MenuFreshnessBadge";
import { MenuSourceBadge } from "./MenuSourceBadge";

type Props = {
  capturedAt?: string | null;
  menuDate?: string | null;
  publishChannel?: string | null;
  viewportSource?: string | null;
  capturedByUser?: string | null;
  isRestaurantClaimed?: boolean;
  className?: string;
};

export function MenuBadgeRow({
  capturedAt,
  menuDate,
  publishChannel,
  viewportSource,
  capturedByUser,
  isRestaurantClaimed,
  className = "",
}: Props) {
  return (
    <div className={`flex flex-wrap items-center gap-1.5 ${className}`}>
      <MenuFreshnessBadge capturedAt={capturedAt} menuDate={menuDate} />
      <MenuSourceBadge
        publishChannel={publishChannel}
        viewportSource={viewportSource}
        capturedByUser={capturedByUser}
        isRestaurantClaimed={isRestaurantClaimed}
      />
    </div>
  );
}

